import React, { useRef, useContext } from 'react';
import { getContext, useCombinedRefs } from 'common';
import { ListContext } from 'components/List';
import { CONSTANTS } from '../common/ListKeyboardNav';
import Styled from './styles';

const {
  LIST_ITEM_TABABLE_ITEM
} = CONSTANTS;


export interface TreeMoreButtonItemProps extends React.ComponentPropsWithRef<'div'> {
  /** Menu item for the `TreeMoreButton` context menu.  Consider using 'TreeMoreButtonItemText'. */
  children: React.ReactNode;
}


/** TreeMoreButton menu item which supports text, icon and other elements.
 * Any other props will be provided to the root element.
 */
const TreeMoreButtonItem = React.forwardRef<HTMLElement, TreeMoreButtonItemProps>((props: TreeMoreButtonItemProps, forwardedRef) => getContext(({ RTL, theme }) => {
  const {
    children,
    ...otherProps
  } = props;
  const listContext = useContext(ListContext);
  const innerRef = useRef(null);
  const ref = useCombinedRefs(forwardedRef, innerRef);

  return (
    <Styled.TreeMoreButtonItem
      className={`${LIST_ITEM_TABABLE_ITEM}-${listContext.uniqueListId}`}
      ref={ref}
      RTL={RTL}
      $theme={theme.LIST.VERTICAL}
      tabIndex={-1}
      role="menuitem"
      hoverEffect
      onFocus={event => event.preventDefault()}
      {...otherProps}
    >
      {children}
    </Styled.TreeMoreButtonItem>
  );
}));

TreeMoreButtonItem.displayName = 'TreeMoreButtonItem';

export default TreeMoreButtonItem;
